import yup from '@/libs/yup';

export default yup.object({
    idn: yup.string().idn().required(),
    title: yup.string(),
    description: yup.string(),
    persona_id: yup.string()
});
